import { render, staticRenderFns } from "./ProjectMapping.vue?vue&type=template&id=72d64b21&"
import script from "./ProjectMapping.vue?vue&type=script&lang=js&"
export * from "./ProjectMapping.vue?vue&type=script&lang=js&"
import style0 from "./ProjectMapping.vue?vue&type=style&index=0&id=72d64b21&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports